import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';
import { headingsSchema } from '../Header';
import ModalOnLoad from './ModalOnLoad';

const schema: JSONSchema7 = {
    title: 'ModalOnLoad',
    type: 'object',
    properties: {
        styles: {
            type: 'string',
            description: 'A stylesheet',
            default: '',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        id: {
            type: 'string',
            title: 'Modal Id',
        },
        titles: headingsSchema,
        closeButtonHtml: {
            type: 'string',
            title: 'Close Button Text',
            default: '<span>Close</span>',
        },
        annotationTag: {
            type: 'string',
            title: 'Annotation Tag',
        },
        acceptButtonText: {
            type: 'string',
            title: 'Accept Button Text',
            default: 'Accept',
        },
        acceptButtonAriaLabel: {
            type: 'string',
            title: 'Accept Button Aria Label',
            default: 'Accept',
        },
        declineButtonText: {
            type: 'string',
            title: 'Decline Button Text',
            default: 'Decline',
        },
        declineButtonAriaLabel: {
            type: 'string',
            title: 'Decline Button Aria Label',
            default: 'Decline',
        },
        linkOnDecline: {
            type: 'string',
            title: 'Link on Decline',
        },
        linkTarget: {
            type: 'string',
            title: 'Target for decline link',
            enum: ['_blank', '_self', '_parent', '_top'],
            default: '_blank',
        },
        rememberCheckboxLabel: {
            type: 'string',
            title: 'Remember Checkbox Label',
            default: 'Remember this selection',
        },
        storageName: {
            type: 'string',
            title: 'Storage Name',
            default: 'modalOnLoad',
        },
        itemToAddInStorage: {
            type: 'string',
            title: 'Item to add in storage',
            default: 'entityId',
            description: 'Add json path for item',
        },
        showModalInEditMode: {
            type: 'boolean',
            title: 'Show modal children in edit mode',
            default: false,
        },
    },
    dependencies: {
        ...customSchemas.layoutSchema.LayoutSchema.dependencies,
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: [
            'id',
            'titles',
            'closeButtonHtml',
            'annotationTag',
            'acceptButtonText',
            'acceptButtonAriaLabel',
            'declineButtonText',
            'declineButtonAriaLabel',
            'linkOnDecline',
            'linkTarget',
            'rememberCheckboxLabel',
            'storageName',
            'itemToAddInStorage',
            'showModalInEditMode',
        ],
    },
];

const uiSchema = {
    'ui:groups': groups,
    ...customSchemas.textSchema.TextSchema.uiSchema,
    ...customSchemas.styleSchema.StyleSchema.uiSchema,
    ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
    styles: {
        'ui:widget': 'CSSEditor',
    },
    id: {
        'ui:widget': 'CustomTextInput',
    },
    titles: {
        items: {
            headerText: {
                'ui:widget': 'ResourcePicker',
            },
        },
    },
    closeButtonHtml: {
        'ui:widget': 'ResourcePicker',
    },
    annotationTag: {
        'ui:widget': 'CustomTextInput',
    },
    acceptButtonText: {
        'ui:widget': 'ResourcePicker',
        'ui:placeholder': '{{ }}',
    },
    acceptButtonAriaLabel: {
        'ui:widget': 'ResourcePicker',
        'ui:placeholder': '{{ }}',
    },
    declineButtonText: {
        'ui:widget': 'ResourcePicker',
        'ui:placeholder': '{{ }}',
    },
    declineButtonAriaLabel: {
        'ui:widget': 'ResourcePicker',
        'ui:placeholder': '{{ }}',
    },
    linkOnDecline: {
        'ui:widget': 'ResourcePicker',
    },
    linkTarget: {
        'ui:widget': 'CustomSelect',
    },
    rememberCheckboxLabel: {
        'ui:widget': 'ResourcePicker',
        'ui:placeholder': '{{ }}',
    },
    storageName: {
        'ui:widget': 'CustomTextInput',
    },
    itemToAddInStorage: {
        'ui:widget': 'CustomTextInput',
    },
    showModalInEditMode: {
        'ui:widget': 'CustomCheckbox',
    },
};

const ModalOnLoadWidget: commonTypes.IWidget = {
    schema,
    uiSchema,
    templateView: ModalOnLoad,
    id: 'ModalOnLoad',
    group: 'component',
    contentPlaceHolders: ['modal'],
    initialData: () => ({
        acceptButtonText: 'Accept',
        declineButtonText: 'Decline',
        closeButtonHtml: '<span>Close</span>',
        showModalInEditMode: false,
    }),
};

export default ModalOnLoadWidget;
